import { OdataFilters, queryCollection } from "helpers/reqparams";
import { body, request } from "services/request";

const resource = "api/AdminPanel";

export interface IntegrationClientListModel {
    clientId: string;
    name: string;
    isActive: boolean;
    createdAt: string;
    lastUsedAt?: string | null;
}

export interface IntegrationClientEditModel {
    clientId: string;
    name: string;
    isActive: boolean;
}

export interface IntegrationClientApplyModel extends IntegrationClientEditModel {
    secret: string | null;
}

export interface IntegrationClientCreatedModel extends IntegrationClientEditModel {
    secret: string;
}

export interface OrganizationIntegrationClientListModel {
    organizationId: number;
    organizationName: string;
    clientId: string;
    technicalUserId: number;
    createdAt: string;
}

export const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, orderBy: "createdAt desc" });
    return request(`${resource}/GetIntegrationClients${query}`, { method: "GET" }, { countInHeaders: true }).catch(
        () => false,
    );
};

export const getIntegrationClient = (clientId: string): Promise<IntegrationClientEditModel | false> =>
    request(`${resource}/GetIntegrationClient/${encodeURIComponent(clientId)}`, { method: "GET" })
        .then((result) => {
            if (!result || typeof result !== "object") {
                return false as const;
            }

            return {
                clientId: result.clientId,
                name: result.name,
                isActive: result.isActive,
            };
        })
        .catch(() => false as const);

export const applyIntegrationClient = (
    model: IntegrationClientApplyModel,
): Promise<IntegrationClientCreatedModel | boolean> =>
    request(`${resource}/ApplyIntegrationClient`, body(model))
        .then((result) => result ?? true)
        .catch(() => false);

export const getOrganizationIntegrationClients = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, orderBy: "createdAt desc" });
    return request(
        `${resource}/GetOrganizationIntegrationClients${query}`,
        { method: "GET" },
        { countInHeaders: true },
    ).catch(() => false);
};

export const applyOrganizationIntegrationClient = (model: { organizationId: number; clientId: string }) =>
    request(`${resource}/ApplyOrganizationIntegrationClient`, body(model)).catch(() => false);

export const deleteOrganizationIntegrationClient = (organizationId: number, clientId: string) =>
    request(`${resource}/DeleteOrganizationIntegrationClient/${organizationId}/${encodeURIComponent(clientId)}`, {
        method: "POST",
    }).catch(() => false);
